export default __webpack_public_path__ + "static/banner-taking-out-a-used-car-loan-0c7c31f693f71b98fea975dedc229407.jpg";